import { Component, ElementRef, ViewChild } from '@angular/core';
import {ViewportRuler} from "@angular/cdk/overlay";

import { Router } from '@angular/router';
import { AbstractComponent } from '../../../../core/common/component/AbstractComponent';

import { Title } from '@angular/platform-browser';
import { DetectService } from './DetectService';

@Component({
  selector: 'app-detect',
  templateUrl: './Detect.html',
  styleUrls: ['./Detect.scss'],
})
export class DetectComponent extends AbstractComponent {

  @ViewChild('canvas', {static: true}) 
  public canvas: ElementRef;  

  //キャンバスエレメント
  public displayLayer;
  public drowingLayer;

  //描画コンテキスト
  public ctxDrowingLayer;

  // キャンバスサイズ
  public canvasY;
  public canvasX;

  public rangeID: string = "";

  public isDraw: boolean = false;

  public isCreate: boolean = false;

  /** canvas */
  public rectangle = {
    startY : 0,
    startX : 0,
    endY : 0,
    endX : 0,
    clear:function () {
        this.startY = 0;
        this.startX = 0;
        this.endY   = 0;
        this.endX   = 0;
    }
  };

  public scope = {
    user_id : 0,
    x : 0,
    y : 0,
    width : 0,
    height : 0,
    disp_width : 0,
    disp_height : 0
  };

  /**  */
  constructor(
    private title: Title,
    private router:Router,
    private service: DetectService,
    private viewportRuler: ViewportRuler) {
      super();
  }

  public componentDidMount() {
    var display = document.getElementById("display");
    var drowing = document.getElementById("drowing");
    this.displayLayer    = display;
    this.drowingLayer    = drowing;
    this.canvasY         = this.drowingLayer.clientHeight;
    this.canvasX         = this.drowingLayer.clientWidth;
    this.ctxDrowingLayer = this.canvas.nativeElement.getContext("2d");

    this.service.get().subscribe((res:any) => {
      if (res.length > 0) {
        this.rangeID = res[0].id;
        this.scope.user_id = res[0].user_id;
      } else {
        this.isCreate = true;
      }
    });
  }

  public onMouseDown (e) {
    this.isDraw = true;
    this.rectangle.startY = e.clientY;
    this.rectangle.startX = e.clientX;
  }

  public onMouseMove (e) {
    if (!this.isDraw) {
      return;
    }
    this.ctxDrowingLayer.clearRect(0, 0, this.canvasX, this.canvasY);
    this.rectangle.endY = e.layerY - this.rectangle.startY;
    this.rectangle.endX = e.layerX - this.rectangle.startX;
    this.ctxDrowingLayer.strokeStyle = "rgb(0, 255, 0)";
    this.ctxDrowingLayer.lineWidth = 1;
    this.ctxDrowingLayer.strokeRect(this.rectangle.startX, this.rectangle.startY, this.rectangle.endX, this.rectangle.endY);
  }

  public onMouseUp (e) {
    this.isDraw = false;
    this.ctxDrowingLayer.strokeStyle = "rgb(0, 255, 255)";
    this.ctxDrowingLayer.lineWidth = 1;
    this.ctxDrowingLayer.strokeRect(this.rectangle.startX, this.rectangle.startY, this.rectangle.endX, this.rectangle.endY);

    let video = document.getElementById("target-video");
    this.scope.width = Math.abs(this.rectangle.endX);
    this.scope.height = Math.abs(this.rectangle.endY);

    if (this.rectangle.endX < 0) {
      this.scope.x = this.rectangle.startX + this.rectangle.endX;
    } else {
      this.scope.x = this.rectangle.startX;
    }
    
    if (this.rectangle.endY < 0) {
      this.scope.y = this.rectangle.startY + this.rectangle.endY;
    } else {
      this.scope.y = this.rectangle.startY;
    }
    
    this.scope.disp_width = video.clientWidth;
    this.scope.disp_height = video.clientHeight;

    this.rectangle.clear();

    if (this.isCreate) {
      this.service.create(this.scope).subscribe((res:any) => {
        this.service.get().subscribe((res:any) => {
          if (res.length > 0) {
            this.scope.user_id = res[0].user_id;
            this.rangeID = res[0].id;
          }
          this.isCreate = false;
        });
      });
    } else {
      this.service.save(this.rangeID, this.scope).subscribe((res:any) => {
        
      });
    }
  }
 
}
